import { useLogo } from "../../../brand";
import ProgressBar from 'react-bootstrap/ProgressBar';



export default function Header(props) {
    const logo = useLogo()

    return(
        <header>
            <div>
                <img src={logo} />
            </div>
            <ProgressBar now={props?.progress || 0} />
        </header>
    )
}